import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "cart-checkout__cart" };
const _hoisted_2 = { class: "container-fluid p-0 m-0" };
const _hoisted_3 = { class: "row p-0 pb-2 m-0 fw-bold border-bottom" };
const _hoisted_4 = { class: "col-12 col-xl-8" };
const _hoisted_5 = { class: "d-none d-xl-block col-xl-2 text-center" };
const _hoisted_6 = { class: "d-none d-xl-block col-xl-2 text-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cart_checkout__line_item = _resolveComponent("g-cart-checkout__line-item");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$tc('client.Commerce.Carts.ItemDescription')), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Quantity')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$tc('client.Commerce.Carts.TotalAmount')), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart.lines, (item) => {
                return (_openBlock(), _createBlock(_component_g_cart_checkout__line_item, {
                    key: item.lineID,
                    cart: _ctx.cart,
                    item: item,
                    schema: _ctx.schema,
                    data: _ctx.data,
                    status: _ctx.status,
                    "is-read-only": false,
                    onCommand: _ctx.onCommand
                }, null, 8, ["cart", "item", "schema", "data", "status", "onCommand"]));
            }), 128))
        ])
    ]));
}
